import { DirectiveType } from '../../types';
import { AbstractToggleDirective } from '../abstract-toggle-directive';
export class UpgradeInsecureRequests extends AbstractToggleDirective {
    getDirectiveName() {
        return 'upgrade-insecure-requests';
    }
    getDirectiveType() {
        return DirectiveType.Other;
    }
}
